<template>
  <div class="CADConfig">
    <div class="infoTit mb20">
      <div class="addArea">
        <!-- <div class="name">广告屏</div> -->
        <div class="infoBtn mr10"><el-button type="primary" @click="addAd">添加</el-button></div>
        <p>建议上传1920*1080规格的jpg图片或1080p的MP4视频，最多能上传10个广告</p>
      </div>
      <div class="infoBtn"><el-button type="primary" @click="getAdsTime">设置</el-button></div>
    </div>
    <!-- <div class="infoCont">
      <el-upload
        action="https://jsonplaceholder.typicode.com/posts/"
        list-type="picture-card"
        :limit="5"
        :on-exceed="overPic"
        :on-remove="handleRemove">
        <i class="el-icon-plus"></i>
      </el-upload>
    </div> -->
    <el-table
      class="adsList"
      border
      :data="adList"
      v-loading="adLoading">
       <el-table-column
        type="index"
        label="序号"
        width="50">
      </el-table-column>
      <el-table-column
        prop="title"
        label="广告标题">
      </el-table-column>
      <el-table-column
        label="广告内容"
        width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="viewAdCont(scope.row)">查看</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="format"
        label="广告格式"
        width="100">
        <template slot-scope="scope">
          {{scope.row.type=='image'?'图片':'视频'}}
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        label="广告位置"
        width="200">
        <template slot-scope="scope">
          <span class="btn-address" v-show="scope.row.location.idle==1">闲置广告</span>
          <span class="btn-address" v-show="scope.row.location.fixed==1">固定广告</span>
          <span v-show="scope.row.location.fixed!=1&&scope.row.location.idle!=1">/</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="format"
        label="分配设备"
        width="100">
        <template slot-scope="scope">
          <span class="deviceNum" @click="openAllotDeviceDio(scope.row)">{{scope.row.bind_device_count}}个</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="setAdL(scope.row)">设置广告位置</el-button>
          <el-button type="text" size="small" @click="delAd(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加 -->
    <el-dialog class="addDio" title="添加广告" :visible.sync="addDio" width="450px">
      <div class="cont_dio">
        <el-form :model="addform" label-width="100px">
          <el-form-item label="广告标题：">
            <el-input class="input" placeholder="请填写标题" v-model="addform.title" type="text"></el-input>
          </el-form-item>
          <el-form-item label="广告格式：">
            <el-select v-model="addform.type" placeholder="请选择">
              <el-option
                v-for="item in typeArr"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="广告内容：">
            <el-upload
              action="#"
              ref="uploadImage"
              accept="image/*"
              :http-request="uploadImage"
              :show-file-list="false"
              v-if="addform.type==='image'">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <el-upload
              action="#"
              ref="uploadFile"
              :http-request="uploadFile"
              :show-file-list="false"
              v-else>
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <p class="">{{fileList[0]}}</p>
            <!-- <el-upload
              class="upload-demo"
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              multiple
              :limit="3"
              :on-exceed="handleExceed"
              :file-list="fileList">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload> -->
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="confirmAddAd">确认</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <!-- 设置 -->
    <el-dialog class="settingDio" title="设置" :visible.sync="settDio" width="350px">
      <div class="cont_dio">
        <el-form :model="settform" label-width="150px">
          <div class="row">
            <p class="tit">轮播设置</p>
            <p class="hint">轮播时间只适用于图片广告</p>
          </div>
          <el-form-item label="闲置广告轮播时间：">
            <el-input class="input" v-model="settform.idle_ads_time" type="number" min="1">
              <template slot="append">秒</template>
            </el-input>
          </el-form-item>
          <el-form-item label="固定广告轮播时间：">
            <el-input class="input" v-model="settform.fixed_ads_time" type="number" min="1">
              <template slot="append">秒</template>
            </el-input>
          </el-form-item>
          <div class="row">
            <p class="tit">时间设置</p>
            <p class="hint">平板不操作显示闲置广告的时间</p>
          </div>
          <el-form-item label="闲置广告出现时间：">
            <el-input class="input" v-model="settform.ads_start_time" type="number" min="1">
              <template slot="append">秒</template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="setAdsTime">确认</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <!-- 查看广告内容 -->
    <el-dialog class="adContDio" title="查看广告内容" :visible.sync="adContDio" width="600px">
      <img class="contnet" :src="adCont.url" v-if="adCont.type==='image'" />
      <video class="contnet" :src="adCont.url" controls="controls" v-else>
        您的浏览器不支持 video 标签。
      </video>
    </el-dialog>

    <!-- 设置广告位置 -->
    <el-dialog class="setAdLDio" title="设置广告位置" :visible.sync="setAdLDio" width="350px">
      <div class="checkbox">
        <el-checkbox v-model="location.idle">闲置广告</el-checkbox>
        <el-checkbox v-model="location.fixed">固定广告</el-checkbox>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmSetAdL">确 认</el-button>
      </span>
    </el-dialog>

    <!-- 删除广告 -->
    <el-dialog class="delAdDio" :visible.sync="delAdDio" width="350px">
      <p class="text">
        确认要删除
        <span class="bold">
          {{delAdInfo.title}}
        </span>
        ？
            </p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="delAdDio = false">取 消</el-button>
              <el-button @click="confirmDelAd()">确 认</el-button>
            </div>
    </el-dialog>

    <!-- 分配设备 -->
    <el-dialog class="allotDeviceDio" title="分配设备" :visible.sync="allotDeviceDio" width="700px">
      <div v-loading="allotDeviceDioLoading" element-loading-background="rgba(240, 243, 248, 0.7)" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
        <div class="topArea">
          <div class="text">已勾选：{{deviceData.row.bind_device_count}}个</div>
        </div>
        <div class="treeWrapper flex">
          <div class="treeBox">
            <p class="ttit treeTit">空间列表</p>
            <div class="treeList">
              <el-tree
                class="defineTree"
                :data="sceneList"
                node-key="id"
                default-expand-all
                :expand-on-click-node="false"
                :props="defaultProps"
                empty-text="暂无空间列表"
                @node-click="deviceNodeClick">
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <!-- 自定义icon -->
                  <i
                    class="defineIcon"
                    :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
                  </i>
                    <!-- @click="getSDeviceList(data.space_id, data.level)" -->
                  <span
                    :class="['label', data.space_id === sceneSelected ? 'selected' : '']">{{ node.label }}</span>
                  <el-checkbox class="check" :indeterminate="data.isIndeterminate" v-model="data.is_bind_ad" @change="checkedChangeOne" :disabled="data.space_id === sceneSelected && deviceData.checkList.length === 0" v-show="data.level >= 1"></el-checkbox>
                </span>
              </el-tree>
            </div>
          </div>
          <div class="checkBox">
            <p class="ttit checkTit">设备列表</p>
            <div class="search">
              <el-input size="small" placeholder="请输入设备ID或设备名称进行搜索" prefix-icon="el-icon-search" v-model="deviceData.keywords" clearable @input="searchDevice"></el-input>
            </div>
            <div class="checkList" v-if="deviceData.checkList.length !== 0">
              <div class="checkItem" v-for="(item,index) in deviceData.checkList" :key="item.device_no_id" @click="deviceData.activeIndex = index">
                <el-checkbox class="checkbox user_name" v-model="item.is_bind_ad" @change="checkedChangeTwo">{{item.device_name}}</el-checkbox>
              </div>
            </div>
            <div class="checkList" v-else>
              <p class="nullText">暂无设备</p>
            </div>
          </div>
        </div>
      </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="allotDeviceDio = false">取消</el-button>
          <el-button type="primary" @click="allocateDevice">确定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
  import { loginApi } from "../../../../static/js/api.js"
  import { showLoading, hideLoading, showToast, deepCopy } from '../../../../static/js/utility/utility'
  import { userApi, sceneApi, adApi } from "../../../../static/js/api.js"
  let vm

  export default {
    name: 'CADConfig',
    components: {
    },
    data() {
      return {
        /** 分配设备 */
        allotDeviceDio: false,
        allotDeviceDioLoading: false,
        allSceneList: [],  // 所有空间列表（非树状）
        sceneList: [],  // 空间列表
        sceneSelected: '', 
        defaultProps: {  // 树形控件配置
          children: 'children',
          label: 'space_name'
        },
        deviceData: {
          list: [],
          aCheckList: [],  // 供搜索时使用
          checkList: [],
          activeIndex: '',
          keywords: '',
          row: '' // 当前操作的广告信息
        },
        isIndeterminate: true,
        checkAll: false,


        /** 设置时间 */
        settDio: false, // 设置时间
        settform:{
          // idle_ads_time: 10,// 闲置轮播时间
          // fixed_ads_time: 10,// 固定轮播时间
        },

        /** 添加广告 */
        addDio: false, // 添加广告
        addform: {
          title: '',
          type: 'image',
          url: ''
        },

        /** 查看广告内容 */
        adContDio: false, //查看广告内容
        adCont: {},

        /** 设置广告位置 */
        setAdLDio: false, //设置广告位置
        location: {
          id: '',
          idle: false,
          fixed: false
        },

        /** 删除广告 */
        delAdDio: false, //删除广告
        delAdInfo: {},
        
        // 广告格式
        typeArr: [
          {
            label: '图片',
            value: 'image'
          },
          {
            label: '视频',
            value: 'video'
          }
        ],

        fileList: [],
        adLoading: false,
        adList: [] 
      }
    },
    created () {
      vm = this 
      vm.getAdsList()
      // vm.getSceneList()
    },
    mounted (){
    },
    methods: {
      // 查看广告内容
      viewAdCont (row) {
        vm.adCont = row
        vm.adContDio = true
      },
      //设置广告位置
      setAdL (row) {
        let location = row.location
        vm.location.id = row.id
        vm.location.idle = location.idle == 1 ? true : false
        vm.location.fixed = location.fixed == 1 ? true : false
        vm.setAdLDio = true
      },
      // 确认设置广告位置
      async confirmSetAdL () {
        console.log(vm.location)
        let data = {
          id: vm.location.id,
          idle: vm.location.idle ? 1 : 0,
          fixed: vm.location.fixed ? 1 : 0
        }
        showLoading('设置中')
        let res = await adApi.setAdsLocation(data)
        hideLoading()
        if (res.meta.code === 200) {
          showToast('设置成功')
          vm.setAdLDio = false
          vm.getAdsList()
        } else {
          showToast(res.meta.message)
        }
      },
      //删除广告位置
      delAd (row) {
        vm.delAdInfo = row
        vm.delAdDio = true
      },
      // 确认删除广告
      async confirmDelAd () {
        let data = { id: vm.delAdInfo.id }
        showLoading('删除中')
        let res = await adApi.deleteAd(data)
        hideLoading()
        if (res.meta.code === 200) {
          showToast('删除成功')
          vm.delAdDio = false
          vm.getAdsList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 获取广告列表
      async getAdsList () {
        vm.adLoading = true
        let res = await adApi.getAdsList()
        vm.adLoading = false
        if (res.meta.code === 200) {
          //console.log(res)
          vm.adList = res.data
        } else {
          showToast(res.meta.message)
        }
      },
      // 添加广告
      addAd () {
        if (vm.adList.length == 10) {
          showToast('已达到10个广告上限，无法添加！')
          return
        }
        vm.addform = {
          title: '',
          type: 'image',
          url: ''
        }
        vm.fileList = []
        vm.addDio = true
      },
      // 确认添加广告
      async confirmAddAd () {
        let data = vm.addform
        if (data.title=== '') {
          showToast('请填写广告标题')
          return
        }
        if (data.url=== '') {
          showToast('请上传广告内容')
          return
        }

        showLoading('正在添加')
        let res = await adApi.addAd(data)
        hideLoading()
        if (res.meta.code === 200) {
          showToast('添加成功')
          vm.addDio = false
          vm.getAdsList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 上传图片
      uploadImage: async function (content) {
        let vm = this
        console.log('content', content)
        let formData = new FormData()
        formData.append('file', content.file)
        let res = await userApi.uploadImage(formData)
        if (res.meta.code === 200) {
          vm.fileList = [content.file.name]
          vm.addform.url = res.data
          showToast('上传成功')
          console.log(vm.fileList)
        } else {
          showToast(res.meta.message)
        }
      },
      //上传文件
      async uploadFile(content){
        let formData = new FormData()
        // console.log('content',content)
        formData.append('file', content.file)
        let res = await adApi.uploadFile(formData)
        if (res.meta.code === 200) {
          vm.fileList = [content.file.name]
          vm.addform.url = res.data
          showToast('上传成功')
          console.log(vm.fileList)
        } else {
          showToast(res.meta.message)
        }
      },

      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      },
      //照片墙超出限制个数
      overPic(file, fileList){
        // console.log('file',file);
        // console.log('fileList',fileList);
      },
      //删除照片墙照片
      handleRemove(file, fileList) {
        // console.log('file',file);
        // console.log('fileList',fileList);
      },
      // 获取轮播时间信息
      async getAdsTime () {
        let res = await adApi.getAdsTime()
        if (res.meta.code === 200) {
          vm.settDio = true
          vm.settform = res.data
        } else {
          showToast(res.meta.message)
        }
      },
      // 设置轮播时间
      async setAdsTime () {
        let data = vm.settform
        showLoading('保存设置中')
        let res = await adApi.setAdsTime(data)
        hideLoading()
        if (res.meta.code === 200) {
          showToast('设置成功')
          vm.settDio = false
        } else {
          showToast(res.meta.message)
        }
      },


      /**
       * 分配设备对话框
       */
      // 打开分配设备对话框
      openAllotDeviceDio (row) {
        vm.deviceData.keywords = ''
        vm.allotDeviceDio = true
        vm.deviceData.row = deepCopy(row)
        vm.allotDeviceDioLoading = true
        vm.getSceneList()
      },
      // 确认分配设备
      allocateDevice () {
        // console.log('list', vm.deviceData.list)
        let device_list = []
        vm.deviceData.list.forEach((item, index)=>{
          if (item.is_bind_ad) { device_list.push(item.device_no_id) }
        })
        // if (device_list.length === 0) {
        //   showToast('请选择要分配的设备')
        //   return
        // }
        // console.log('device_list', device_list)
        let data = {
          ad_id: vm.deviceData.row.id,
          device_list
        }
        vm.bindDeviceAds(data)
      },
      // 广告绑定设备
      async bindDeviceAds (data) {
        let res = await adApi.bindDeviceAds(data)
        if (res.meta.code === 200) {
          showToast('分配成功')
          vm.allotDeviceDio = false
          vm.getAdsList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 更新所有设备列表
      updateDeviceList (two) {
        // console.log('checkList', vm.deviceData.checkList)
        let list = deepCopy(vm.deviceData.list)
        let checkList = vm.deviceData.checkList
        
        if (two) {
          let newItem = checkList[vm.deviceData.activeIndex]
          // console.log('newItem', newItem)
          list.forEach((item, i)=>{
            if (item.device_no_id === newItem.device_no_id) {
              // console.log('newItem', item.is_bind_ad, newItem.is_bind_ad)
              vm.$set(vm.deviceData.list, i, newItem)
              let count = Number(vm.deviceData.row.bind_device_count)
              count += newItem.is_bind_ad ? 1 : -1
              vm.deviceData.row.bind_device_count = count
            }
          })
        } else { //批量操作
          let rev = (num) => {
            let newItem = checkList[num]
            list.forEach((item, i)=>{
              if (item.device_no_id === newItem.device_no_id) {
                // console.log('newItem', item.is_bind_ad, newItem.is_bind_ad)
                vm.$set(vm.deviceData.list, i, newItem)
                let count = Number(vm.deviceData.row.bind_device_count)
                if (!item.is_bind_ad && newItem.is_bind_ad) { count = count+1 } 
                else if (item.is_bind_ad && !newItem.is_bind_ad) { count = count-1 }
                vm.deviceData.row.bind_device_count = count
              }
            })
            if (num+1 < checkList.length) {
              rev(num+1)
            }
          }
          rev(0)
        }
      },
      /** 分配设备——空间列表 */
      // 监听是否选择空间
      checkedChangeOne (value) {
        // console.log('选择', '')
        // 清空搜索字段
        vm.deviceData.keywords = ''
        let checkList = vm.deviceData.checkList
        checkList.forEach((item, index)=>{
          checkList[index].is_bind_ad = value
        })
        // vm.deviceData.aCheckList = checkList
        vm.deviceData.checkList = deepCopy(checkList) // 更新设备列表
        vm.updateDeviceList()  // 更新所有设备列表
        // 修改空间的checkBox状态
        vm.allSceneList.forEach((item, index)=>{
          let newItem = deepCopy(item)
          if (item.space_id === vm.sceneSelected) {
            newItem.is_bind_ad = value
            newItem.isIndeterminate = false
            vm.$set(vm.allSceneList, index, newItem)
          }
        })
        vm.sceneList = vm.toGetList() // 更新空间列表
      },
      // 获取当前地址所有设备的选择状态（-1全不选，0部分选， 1全选）
      getSpaceDeviceStatus () {
        let checkList = [...vm.deviceData.checkList]
        let ANDVal = true, ORval = false
        checkList.forEach((cItem, cIndex)=>{
          ANDVal = ANDVal && cItem.is_bind_ad
          ORval = ORval || cItem.is_bind_ad
        })
        // -1全不选，0部分选， 1全选
        let status = !ANDVal && !ORval ? -1 :
                     !ANDVal && ORval ? 0 :
                     ANDVal && ORval ? 1 : ''
        // console.log('ANDVal::', ANDVal)
        // console.log('ORval::', ORval)
        // console.log('status', status)
        return status
      },
      // 获取父地址id数组
      getPidArr() {
        let pidArr = []
        let list = vm.allSceneList
        for (let i = 0; i < list.length; i++) {
          let item = list[i]
          if (pidArr.indexOf(item.parent_id) === -1) {
            if (item.parent_id != undefined) {
              pidArr.unshift(item.parent_id)
            }
          }
        }
        return pidArr
      },
      //  根据allSenceList获取空间列表
      toGetList() {
        let temArr = this.getPidArr()
        let allList = deepCopy(vm.allSceneList)
        let newList = []
        // console.log('temArr', temArr)

        //获取新地址列表 （部门不超过五级）
        let rev = (num) => {
          // console.log('num____________', num)
          let afterInfo = {}, children = []
          for (let i = 0; i < [...allList].length; i++) {
            let item = allList[i]
            let p_id = temArr[num]
            if (item.space_id === p_id) {
              afterInfo = item
            } else if (item.parent_id === p_id) {
              children.unshift(item)
            }
          }

          // 将新增的地址信息添加到同级地址的下方
          if (afterInfo.children) {
            afterInfo.children[0].space_id = afterInfo.children[0].parent_id + (children.length + 1)
            children.unshift(afterInfo.children[0])
          }
          afterInfo.children = children

          if (num + 1 < temArr.length) {
            rev(num + 1)
          } else {
            newList = [afterInfo]
          }
        }
        rev(0)
        // console.log('newList', newList)
        return newList[0].children
      },
      // 获取空间列表
      async getSceneList () {
        let data = {
          ad_id: vm.deviceData.row.id
        }
        let res = await sceneApi.space(data)
        if (res.meta.code === 200) {
          vm.sceneList = res.data
          vm.allSceneList = vm.getAllList()
          vm.getSpaceDeviceList()
        } else {
          vm.allotDeviceDioLoading = false
          showToast(res.meta.message)
        }
      },
      // 获取所有空间列表（非树状）
      getAllList () {
        let list = [...vm.sceneList]
        let allList = []
        let rev = (arr)=>{
          arr.forEach((item,index)=>{
            let newItem = deepCopy(item)
            if (newItem.children) {
              delete(newItem.children)
              rev(item.children)
            }
            allList.unshift(newItem)
          })
        }
        rev(list, [])
        return allList
        // console.log('allList', allList)
      },

      /** 分配设备——设备列表 */
      // 监听是否选择设备
      checkedChangeTwo (value) {
        vm.updateDeviceList('two', value)
        let status = vm.getSpaceDeviceStatus() // （-1全不选，0部分选， 1全选）
        // 修改空间的checkBox状态
        vm.allSceneList.forEach((item, index)=>{
          let newItem = deepCopy(item)
          if (item.space_id === vm.sceneSelected) {
            newItem.is_bind_ad = status == 1 ? true : false
            newItem.isIndeterminate = status == 0 ? true : false
            vm.$set(vm.allSceneList, index, newItem)
          }
        })
        vm.sceneList = vm.toGetList() // 更新空间列表
      },
      // 搜索设备
      searchDevice () {
        // console.log('keywords', vm.deviceData.keywords)
        let keywords = vm.deviceData.keywords
        // 当前空间的设备列表
        let aCheckList = [...vm.deviceData.aCheckList]
        let newList = []
        vm.deviceData.checkList = []
        aCheckList.forEach(function (item, index) {
          let newItem = {}
          // console.log('item.device_no_id', item.device_no_id)
          if (item.device_no_id.includes(keywords)) { newItem = item }
          if (item.device_name.includes(keywords)) { newItem = item }
          if (newItem.device_no_id) { newList.push(newItem)  }
          // console.log('newItem', newItem)
        })
        vm.deviceData.checkList = newList
      },
      // 根据设备id获取设备列表
      getSDeviceList (space_id, level) {
        // console.log('更新列表', '')
        if (level < 1) return
        vm.sceneSelected = space_id
        let list = vm.deviceData.list, newList = []
        list.forEach((item, index)=>{
          if (item.space_id === space_id) {
            newList.push(item)
          }
        })
        vm.deviceData.aCheckList = deepCopy(newList)
        vm.deviceData.checkList = deepCopy(newList)
      },
      // 获取所有位置设备列表
      async getSpaceDeviceList () {
        let data = {
          page: 1,
          perPage: 999999,
          ad_id: vm.deviceData.row.id
        }
        let res = await sceneApi.getSpaceDeviceList(data)
        vm.allotDeviceDioLoading = false
        if (res.meta.code === 200) {
          let list = [...res.data.list]
          vm.deviceData.list = list
          vm.getSDeviceList(vm.sceneList[0].children[0].children[0].space_id)
        } else {
          showToast(res.meta.message)
        }
      },
      // 设备树形列表节点
      deviceNodeClick(data) {
        // console.log(data)
        this.getSDeviceList(data.space_id, data.level)
      },
    },
    watch: {
    }
  }
</script>

<style lang="scss">
.CADConfig{
  .infoTit {
    .addArea {
      display: flex;
      align-items: center;
      p {
        margin-bottom: 0;
      }
    }
  }

  .adsList {
    .btn-address {
      display: inline-block;
      padding: 5px 10px;
      font-size: 14px;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
    }
    .deviceNum {
      color: #409EFF;
      text-decoration: underline;
    }
  }
  

  // 添加广告
  .addDio {
    .input {
      width: 100%;
    }
  }
  // 设置对话框
  .settingDio {
    .row {
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      .tit {
        font-size: 16px;
        font-weight: bold;
        margin-right: 10px;
      }
      .hint {
        font-size: 14px;
        // color: #999;
        color: #f95757;
      }
    }
    .input {
      input {
        text-align: right;
      }
    }
  }
  // 查看广告内容
  .adContDio {
    .contnet {
      width: 100%;
    }
  }
  // 分配设备
  .allotDeviceDio {
    .topArea {
      .text {
        font-size: 14px;
        margin-bottom: 10px;
      }
    }
    .treeWrapper{
      width: 100%;
      height: 340px;
      border: 1px solid #eee;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      .ttit {
        flex-shrink: 0;
        width: 100%;
        height: 40px;
        line-height: 40px;
        text-indent: 1em;
        background-color: #cccccc;
      }
      .treeBox{
        flex-shrink: 0;
        width: 44%;
        height: 100%;
        border-right: 1px solid #eee;
        display: flex;
        flex-direction: column;
        .treeList {
          width: 100%;
          height: 100%;
          overflow-y: auto;
          .check {
            margin-top: 4px;
            position: absolute;
            right: 20px;
            // top: 6px;
          }
        }
      }
      .checkBox {
        flex-shrink: 0;
        width: 56%;
        height: 100%;
        display: flex;
        flex-direction: column;
        // 搜索
        .search {
          width: 260px;
          margin: 10px auto;
          input {
            border-radius: 32px;
          }
        }
        .checkList{
          width: 100%;
          height: 100%;
          padding: 10px 20px 0;
          border-top: 1px solid #eeeeee;
          overflow-y: auto;
          .checkItem{
            width: 100%;
            .checkbox{ 
              margin-bottom: 10px;
              display: flex;
              align-items: center;
              .el-checkbox__label{
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
          .nullText{
            margin-top: 100px;
            text-align: center;
          }
          .search{
            text-align: center;
            padding: 6px 0 0;
            .el-input{
              width: 70%;
              .el-input__inner{
                border-radius: 16px;
              }
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Page/COther/CADConfig.vue